import { useState } from "react";
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION } from "../../../../../ApiServices/BaseURL";

const InvoiceSeriesController = (onRefresh,toggleInvoiceSeries) => {
    const [deleteLoading, setDeleteLoading] = useState({});
    const [deleteError, setDeleteError] = useState({});
    const [deleteSuccess, setDeleteSuccess] = useState({});
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const handleEdit = (item) => {
        console.log("Edit item:", item);
        // Implement edit logic here
    };

    const handleDeleteServiceType = (service) => {
        setSelectedInvoice(service);
        setIsDeleteModalOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false); // Close the modal
    };

    const callDeleteServiceType = async (service) => {
        try {
            setDeleteError({});
            setDeleteError((prev) => ({ ...prev, [service?.series_id]: '' }));
            setDeleteLoading((prev) => ({ ...prev, [service?.series_id]: true }));
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "action": "INVOICE_SERIES_DELETE",
                "emp_id_auth": storedUserInfo?.emp_id,
                "series_id": service?.series_id,
            }

            //console.log('callDeleteServiceType payload',payLoad);

            // Make the API call
            const response = await postData(ORG_CONFIGURATION, payLoad);
            const responseData = await response.json();
            //console.log('callDeleteServiceType response Data',responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setDeleteSuccess((prev) => ({ ...prev, [service?.series_id]: responseData?.info }));
                        setTimeout(() => {
                            setDeleteSuccess((prev) => ({ ...prev, [service?.series_id]: '' }));
                            onRefresh();
                            toggleInvoiceSeries();
                        }, 3000);
                    } else {
                        setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Failed to delete service. Please try again.' }));
                    }
                } else {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Failed to delete service. Please try again...' }));
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
                } else {
                    setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Bad request. Please check the request parameters.' }));
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: responseData?.info || 'Internal Server Error. Please try again later.' }));
            }
            // Unexpected or network-related errors
            else {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: 'Unexpected error occurred. Please try again later.' }));
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: `Error: ${error.response.status}. ${error.response.data?.message || 'Failed to delete service. Please try again.'}` }));
            } else if (error.request) {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: 'No response received from the server. Please check your network connection and try again.' }));
            } else {
                setDeleteError((prev) => ({ ...prev, [service?.series_id]: `Failed to delete service data. Please check your network connection and try again.` }));
            }
        } finally {
            setDeleteLoading((prev) => ({ ...prev, [service?.series_id]: false }));
        }
    }

    return {
        deleteLoading,
        deleteError,
        deleteSuccess,
        handleEdit,
        handleDeleteServiceType,
        callDeleteServiceType,
        isDeleteModalOpen,
        selectedInvoice,
        handleCloseDeleteModal,
    };
};

export default InvoiceSeriesController;
